let currentOpenDropButtons = [];

const toggleDropButton = (event) => {
  let dropButtonList = event.target.nextElementSibling;

  if ("true" === event.target.getAttribute("aria-expanded")) {
    event.target.setAttribute("aria-expanded", false);
    dropButtonList.classList.toggle("submenu--expanded");
    dropButtonList.setAttribute("aria-expanded", false);
    let index = currentOpenDropButtons.indexOf(event);
    if (index > -1) {
      currentOpenDropButtons.splice(index, 1);
    }
  } else {
    event.target.setAttribute("aria-expanded", true);
    dropButtonList.classList.toggle("submenu--expanded");
    dropButtonList.setAttribute("aria-expanded", true);
    currentOpenDropButtons.push(event);
  }
};

const closeAllOpenDropButtons = (event) => {
  if (!event.target.closest(".drop-chooser") || 27 === event.keyCode) {
    Array.from(currentOpenDropButtons).forEach((dropButton) => {
      let dropButtonList = dropButton.target.nextElementSibling;

      if ("true" === dropButton.target.getAttribute("aria-expanded")) {
        dropButton.target.setAttribute("aria-expanded", false);
        dropButtonList.classList.toggle("submenu--expanded");
        dropButtonList.setAttribute("aria-expanded", false);
        let index = currentOpenDropButtons.indexOf(dropButton);
        if (index > -1) {
          currentOpenDropButtons.splice(index, 1);
        }
      }
    });
  }
};

export const eventListenerDropButton = () => {
  var dropBtnsArray = document.getElementsByClassName("drop-chooser__btn");
  Array.from(dropBtnsArray).forEach((element) => {
    element.addEventListener("click", (e) => toggleDropButton(e));
  });

  var dropBtnAreas = document.getElementsByClassName("drop-chooser");
  Array.from(dropBtnAreas).forEach((element) => {
    element.addEventListener("keyup", (e) => closeAllOpenDropButtons(e));
  });

  document.addEventListener("click", (e) => closeAllOpenDropButtons(e));
};

export const eventListenerCloseBlock = () => {
    var closeBlockArray = document.getElementsByClassName("close-block__button");
    Array.from(closeBlockArray).forEach((element) => {
        element.addEventListener("click", (e) => {
            element.closest('.takeover').classList.add("takeover--closed");
        });
    });
};


